import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, DialogContentText, Modal, ModalProps } from '@p81-common/ui';

interface SWGControlConfirmModalProps {
  open: ModalProps['open'];
  onConfirm: (event?: React.MouseEvent) => void | Promise<void>;
  onClose: (event?: React.MouseEvent) => void;
}

export const SWGControlConfirmModal: React.FC<SWGControlConfirmModalProps> = ({
  open,
  onConfirm,
  onClose
}) => {
  const { t } = useTranslation(['activity']);

  return (
    <Modal
      id="swgControlConfirmModal"
      open={open}
      dialogActionsProps={{
        children: (
          <>
            <Button variant="text" color="primary" onClick={onClose}>
              {t('activity:buttons.CANCEL')}
            </Button>
            <Button color="primary" onClick={onConfirm}>
              {t('activity:buttons.YES')}
            </Button>
          </>
        )
      }}
      dialogContentProps={{
        children: (
          <DialogContentText>
            {t('activity:SWG_RETURN_CONTROL')}
          </DialogContentText>
        )
      }}
      dialogTitleProps={{
        children: t('activity:SWG_CONTROL_TITLE')
      }}
      onClose={onClose}
    />
  );
};
